import React from "react";
import { FaChevronLeft } from "react-icons/fa";

export const ProjectDetails = () => {
  return (
    <div className="project-details">
    <a className="back-to-projects" href="/projects">
              <span><FaChevronLeft /></span>
      <p>
      Back to projects
      </p>
</a>
      <h1 className="project-title-info">Miami Beach Project</h1>
      <h2  className="work-description">Residential New construction</h2>
      <p className="work-details">Porcelain, slabs, natural stone installations including floors, bathrooms, façades, fireplace, pool interior and pool deck.
</p>
    </div>
  );
};
